export const GET_FORM_BS_REQUEST = "GET_FORM_BS_REQUEST";
export const GET_FORM_BS_SUCCESS = "GET_FORM_BS_SUCCESS";
export const GET_FORM_BS_FAILURE = "GET_FORM_BS_FAILURE";
